import React, {useEffect, useMemo} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {t} from "i18next";
import {useSelector} from "react-redux";
import {stepOptions} from "../../flowManager/StepOptions";
import {PLUGIN_REFERER} from "../../../../src/constants";

const useTabName = (props) => {
    const { langReady } = props;
    const box = useSelector(state => state.site.box)
    const currStep = useSelector(state => state.stepper.currStep)
    const targetName = useSelector(state => state.stepper.targetName)
    const referrer = useSelector(state => state.site?.referrer)
    const isPlugin = referrer === PLUGIN_REFERER
    const location = useLocation();
    const params = useParams();
    const extras = useMemo(() => ` - ${box?.name} | Arbox`, [box]);

    useEffect(() => {
        if(location.pathname && params && langReady) {
            const name = getTabName()
            console.log('tab name: ',name)
            document.title = name
        }
    }, [location.pathname, params, langReady, targetName]);

    useEffect(() => {
        if([stepOptions.PAYMENT, stepOptions.SUCCESS, stepOptions.WAIVER, stepOptions.AVAILABILITY_SLOT, stepOptions.COURSE_CHILD_DETAILS, stepOptions.COURSE_CHILD_SELECTION].includes(currStep)) {
            document.title = `${t(`${currStep}-tab-name`)}${extras}`
        } else {
            const name = getTabName()
            document.title = name
        }
    }, [currStep]);

    const getTabName = () => {
        const routeName = location.pathname.toLowerCase().split('/')[1]
        let tabName = ''
        if(targetName) {
            tabName = targetName
        } else {
            if (routeName === '') {
                if(isPlugin) {
                    tabName = t('lead-form-tab-name')
                } else {
                    tabName = t('home-tab-name')
                }
            } else if (routeName === '404') {
                tabName = t('not-found-tab-name')
            } else {
                tabName = t(`${routeName}-tab-name`)
            }
        }

        return `${tabName}${extras}`
    }

};

export default useTabName;